import axios from "axios";
import {
  ADD_CAMPAIGN_API,
  ADD_CATEGORY_API,
  ADD_CATEGORY_CONTACT_API,
  ADD_INFORMATION_API,
  ADD_LANGUAGE_API,
  ADD_NEWS_API,
  ADD_OFFER_API,
  ADD_PRODUCT_API,
  ADD_QUESTION_API,
  ADD_QUIZ_API,
  ADD_ROLE_API,
  ADD_SHOP_API,
  ADD_SOCIAL_LINK_API,
  ADD_SUB_ADMIN_API,
  ADD_SUBCATEGORY_API,
  ADD_USER_API,
  ADD_WEBLINK_API,
  ADD_WHATSNEW_API,
  ALLOWED_MODULES_API,
  BLOCK_CATEGORY_API,
  CATEGORY_LIST_API,
  CHANGE_PASSWORD_API,
  DASHBOARD_COUNT_API,
  DELETE_CAMPAIGN_API,
  DELETE_CONTACT_API,
  DELETE_INFORMATION_API,
  DELETE_NEWS_API,
  DELETE_OFFER_API,
  DELETE_PRODUCT_API,
  DELETE_PRODUCT_IMAGE_API,
  DELETE_QUESTION_API,
  DELETE_QUIZ_API,
  DELETE_ROLE_API,
  DELETE_SHOP_API,
  DELETE_SOCIAL_LINK_API,
  DELETE_SUBCATEGORY_API,
  DELETE_USER_API,
  DELETE_WEBLINK_API,
  DELETE_WHATSNEW_API,
  EDIT_CATEGORY_API,
  EDIT_SUB_ADMIN_API,
  EDIT_USER_API,
  GET_CAMPAIGN_DETAILS,
  GET_CAMPAIGN_LIST,
  GET_LANGUAGE_API,
  GET_NEWS_API,
  GET_PRODUCT_DETAILS,
  GET_PRODUCT_LIST,
  GET_QUESTION_API,
  GET_QUIZ_API,
  GET_ROLE_API,
  GET_UNREAD_NOTIFICATION_COUNT,
  GET_WEBLINK_API,
  LIST_INFORMATION_API,
  LIST_MODULES_API,
  LIST_NOTIFICATION_API,
  LIST_OFFER_API,
  LIST_ROLE_API,
  LIST_SHOP_API,
  LIST_SOCIAL_LINK_API,
  LIST_SUBCATEGORY_API,
  LIST_WHATSNEW_API,
  OFFER_USERLIST_API,
  SUB_ADMIN_LIST_API,
  SUBCATEGORY_LIST_API,
  UPDATE_CAMPAIGN_DETAILS,
  UPDATE_INFORMATION_API,
  UPDATE_LANGUAGE_API,
  UPDATE_NEWS_API,
  UPDATE_OFFER_API,
  UPDATE_PRODUCT_API,
  UPDATE_QUESTION_API,
  UPDATE_QUIZ_API,
  UPDATE_ROLE_API,
  UPDATE_SHOP_API,
  UPDATE_SOCIAL_LINK_API,
  UPDATE_SUBCATEGORY_API,
  UPDATE_WEBLINK_API,
  UPDATE_WHATSNEW_API,
  USER_LIST_API,
} from "./Api";
import Cookies from "js-cookie";

axios.interceptors.request.use(
  (config) => {
    const token = Cookies.get("e_learning_token");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

const headers = {
  "Content-type": "application/json",
};

export const getDashboardCount = () => {
  return axios.get(DASHBOARD_COUNT_API, {
    headers: headers,
  });
};

export const getUserList = (param) => {
  return axios.get(USER_LIST_API, {
    headers: headers,
    params: param,
  });
};

export const addUsers = (param) => {
  return axios.post(ADD_USER_API, param);
};

export const updateUsers = (param) => {
  return axios.put(EDIT_USER_API, param);
};

export const deleteUsers = (param) => {
  return axios.delete(DELETE_USER_API, {
    headers: headers,
    params: param,
  });
};

export const allowModuleApi = (param) => {
  return axios.get(ALLOWED_MODULES_API, {
    headers: headers,
    params: param,
  });
};

export const getSubAdminList = (param) => {
  return axios.get(SUB_ADMIN_LIST_API, {
    headers: headers,
    params: param,
  });
};

export const addSubAdmin = (param) => {
  return axios.post(ADD_SUB_ADMIN_API, param);
};

export const updateSubAdmin = (param) => {
  return axios.put(EDIT_SUB_ADMIN_API, param);
};

export const getModuleApi = () => {
  return axios.get(LIST_MODULES_API);
};

export const addCategoryApi = (param) => {
  return axios.post(ADD_CATEGORY_API, param);
};

export const getCategoryList = () => {
  return axios.get(CATEGORY_LIST_API, {
    headers: headers,
  });
};

export const updateCategory = (param) => {
  return axios.put(EDIT_CATEGORY_API, param);
};

export const addCategoryContact = (param) => {
  return axios.post(ADD_CATEGORY_CONTACT_API, param);
};

export const deleteCategoryContact = (param) => {
  return axios.delete(DELETE_CONTACT_API, {
    params: param,
  });
};

export const blockCategoryApi = (param) => {
  return axios.put(BLOCK_CATEGORY_API, param);
};

export const getSubcategoryList = (param) => {
  return axios.get(SUBCATEGORY_LIST_API, {
    headers: headers,
    params: param,
  });
};

export const addSubcategory = (param) => {
  return axios.post(ADD_SUBCATEGORY_API, param);
};

export const updateSubcategory = (param) => {
  return axios.put(UPDATE_SUBCATEGORY_API, param);
};

export const deleteSubcategory = (param) => {
  return axios.delete(DELETE_SUBCATEGORY_API + `?subcategory_id=${param}`, {
    headers: headers,
  });
};

export const listSubcategory = (param) => {
  return axios.get(LIST_SUBCATEGORY_API, {
    headers: headers,
    params: param,
  });
};

export const getUserRole = (param) => {
  return axios.get(GET_ROLE_API, {
    headers: headers,
    params: param,
  });
};

export const addUserRole = (param) => {
  return axios.post(ADD_ROLE_API, param, {
    headers: headers,
  });
};

export const listUserRole = () => {
  return axios.get(LIST_ROLE_API, {
    headers: headers,
  });
};

export const deleteUserRole = (param) => {
  return axios.delete(DELETE_ROLE_API, {
    headers: headers,
    params: param,
  });
};

export const updateUserRole = (param) => {
  return axios.put(UPDATE_ROLE_API, param, {
    headers: headers,
  });
};

export const addQuiz = (param) => {
  return axios.post(ADD_QUIZ_API, param);
};

export const getQuizList = (param) => {
  return axios.get(GET_QUIZ_API, {
    headers: headers,
    params: param,
  });
};

export const deleteQuiz = (param) => {
  return axios.delete(DELETE_QUIZ_API, {
    headers: headers,
    params: param,
  });
};

export const updateQuiz = (param) => {
  return axios.put(UPDATE_QUIZ_API, param);
};

export const addWeblink = (param) => {
  return axios.post(ADD_WEBLINK_API, param);
};

export const getWeblink = (param) => {
  return axios.get(GET_WEBLINK_API, {
    headers: headers,
    params: param,
  });
};

export const updateWeblink = (param) => {
  return axios.put(UPDATE_WEBLINK_API, param, {
    headers: headers,
  });
};

export const deleteWeblink = (param) => {
  return axios.delete(DELETE_WEBLINK_API, {
    headers: headers,
    params: param,
  });
};

export const getNews = (param) => {
  return axios.get(GET_NEWS_API, {
    headers: headers,
    params: param,
  });
};

export const addNews = (param) => {
  return axios.post(ADD_NEWS_API, param);
};

export const updateNews = (param) => {
  return axios.put(UPDATE_NEWS_API, param);
};

export const deleteNews = (param) => {
  return axios.delete(DELETE_NEWS_API, {
    headers: headers,
    params: param,
  });
};

export const getLanguage = (param) => {
  return axios.get(GET_LANGUAGE_API, {
    headers: headers,
    params: param,
  });
};

export const addLanguage = (param) => {
  return axios.post(ADD_LANGUAGE_API, param);
};

export const updateLanguage = (param) => {
  return axios.put(UPDATE_LANGUAGE_API, param);
};

export const getQuestion = (param) => {
  return axios.get(GET_QUESTION_API, {
    headers: headers,
    params: param,
  });
};

export const addQuestion = (param) => {
  return axios.post(ADD_QUESTION_API, param);
};

export const updateQuestion = (param) => {
  return axios.put(UPDATE_QUESTION_API, param);
};

export const deleteQuestion = (param) => {
  return axios.delete(DELETE_QUESTION_API, {
    headers: headers,
    params: param,
  });
};

export const changePasswordApi = (param) => {
  return axios.put(CHANGE_PASSWORD_API, param, {
    headers: headers,
  });
};

export const addProductApi = (param) => {
  return axios.post(ADD_PRODUCT_API, param);
};

export const getProductList = (param) => {
  return axios.get(GET_PRODUCT_LIST, {
    headers: headers,
    params: param,
  });
};

export const deleteProductApi = (param) => {
  return axios.delete(DELETE_PRODUCT_API, {
    headers: headers,
    params: param,
  });
};

export const getProductDetails = (param) => {
  return axios.get(GET_PRODUCT_DETAILS, {
    headers: headers,
    params: param,
  });
};

export const deleteProductImageApi = (param) => {
  return axios.delete(DELETE_PRODUCT_IMAGE_API + `?image_id=${param}`, {
    headers: headers,
  });
};

export const updateProduct = (param) => {
  return axios.put(UPDATE_PRODUCT_API, param);
};

export const getCampainList = (param) => {
  return axios.get(GET_CAMPAIGN_LIST, {
    headers: headers,
    params: param,
  });
};

export const addCampaignApi = (param) => {
  return axios.post(ADD_CAMPAIGN_API, param);
};

export const deleteCampaignApi = (param) => {
  return axios.delete(DELETE_CAMPAIGN_API, {
    headers: headers,
    params: param,
  });
};

export const getCampaignDetails = (param) => {
  return axios.get(GET_CAMPAIGN_DETAILS, {
    headers: headers,
    params: param,
  });
};

export const updateCampaign = (param) => {
  return axios.put(UPDATE_CAMPAIGN_DETAILS, param);
};

export const getOffersDetails = (param) => {
  return axios.get(LIST_OFFER_API, {
    headers: headers,
    params: param,
  });
};

export const addOffers = (param) => {
  return axios.post(ADD_OFFER_API, param);
};

export const updatedOffers = (param) => {
  return axios.put(UPDATE_OFFER_API, param);
};

export const deleteOffers = (param) => {
  return axios.delete(DELETE_OFFER_API, {
    headers: headers,
    params: param,
  });
};

export const offerUserList = (param) => {
  return axios.get(OFFER_USERLIST_API, {
    headers: headers,
    params: param,
  });
};

export const getStoreDetails = (param) => {
  return axios.get(LIST_SHOP_API, {
    headers: headers,
    params: param,
  });
};

export const addStore = (param) => {
  return axios.post(ADD_SHOP_API, param);
};

export const updatedStore = (param) => {
  return axios.put(UPDATE_SHOP_API, param);
};

export const deleteStore = (param) => {
  return axios.delete(DELETE_SHOP_API, {
    headers: headers,
    params: param,
  });
};

export const getSocialLink = (param) => {
  return axios.get(LIST_SOCIAL_LINK_API, {
    headers: headers,
    params: param,
  });
};

export const addSocialLink = (param) => {
  return axios.post(ADD_SOCIAL_LINK_API, param);
};

export const updatedSocialLink = (param) => {
  return axios.put(UPDATE_SOCIAL_LINK_API, param);
};

export const deleteSocialLink = (param) => {
  return axios.delete(DELETE_SOCIAL_LINK_API, {
    headers: headers,
    params: param,
  });
};

export const getInformation = (param) => {
  return axios.get(LIST_INFORMATION_API, {
    headers: headers,
    params: param,
  });
};

export const addInformation = (param) => {
  return axios.post(ADD_INFORMATION_API, param);
};

export const updatedInformation = (param) => {
  return axios.put(UPDATE_INFORMATION_API, param);
};

export const deleteInformation = (param) => {
  return axios.delete(DELETE_INFORMATION_API, {
    headers: headers,
    params: param,
  });
};

export const getWhatsNew = (param) => {
  return axios.get(LIST_WHATSNEW_API, {
    headers: headers,
    params: param,
  });
};

export const addWhatsNew = (param) => {
  return axios.post(ADD_WHATSNEW_API, param);
};

export const updatedWhatsNew = (param) => {
  return axios.put(UPDATE_WHATSNEW_API, param);
};

export const deleteWhatsNew = (param) => {
  return axios.delete(DELETE_WHATSNEW_API, {
    headers: headers,
    params: param,
  });
};

export const getNotification = (param) => {
  return axios.get(LIST_NOTIFICATION_API, {
    headers: headers,
    params: param,
  });
}

export const getUnreadNotificationCount = () => {
  return axios.get(GET_UNREAD_NOTIFICATION_COUNT, {
    headers: headers,
  });
}